import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { TrackableSurface } from "../utils/eventNames";
import type { QueryOpts } from "./useTrackingEvents";

export interface EntityUser {
	user_id: string;
	full_name: string | null;
	job_title: string | null;
	org_team_level_one: string | null;
	first_seen: string;
	last_seen: string;
	seen: boolean;
	clicked: boolean;
}

export interface EntityUsersResponse {
	surface: string;
	entity_id: string;
	from: string;
	to: string;
	page: number;
	page_size: number;
	total: number;
	users: EntityUser[];
}

export interface EntityUsersArgs {
	surface: TrackableSurface;
	entityId: string;
	from: Date;
	to: Date;
	page: number;
	pageSize?: number;
}

const useTrackingEntityUsers = (args: EntityUsersArgs, options?: QueryOpts) =>
	useQuery(
		[
			"tracking",
			"entity-users",
			args.surface,
			args.entityId,
			args.from.toISOString(),
			args.to.toISOString(),
			args.page,
			args.pageSize ?? 25
		],
		async () => {
			const { data } = await cmsClient.get<EntityUsersResponse>(
				"/tracking/entity-users/",
				{
					params: {
						surface: args.surface,
						entity_id: args.entityId,
						from: args.from.toISOString(),
						to: args.to.toISOString(),
						page: args.page,
						page_size: args.pageSize ?? 25
					}
				}
			);
			return data;
		},
		{
			enabled: !!args.entityId && (options?.enabled ?? true),
			staleTime: 0,
			cacheTime: 0
		}
	);

export default useTrackingEntityUsers;
